import HorizontalHomecard from './HorizontalHomecard';

export default HorizontalHomecard;
